module.exports = __webpack_public_path__ + "images/00c6925a2499f27cbfe416d1083c3182.png";